export default function PropertyType({wrapperClass,value='single',setValue}){

    return (
        <div className={`w-[100%] mb-[10px] relative ${wrapperClass}`}>
            <div className="text-center">
                <div className="flex gap-[0] w-full max-w-[330px] rounded-[40px] items-center mx-auto shadow-[0px_8px_24px_0px_rgba(0,0,0,0.07)]">
                    <div className={`w-[50%] h-[40px] bg-white rounded-[30px] leading-[40px] text-center text-[20px] text-grey-900 font-[200] select-none cursor-pointer ${value === 'single' ? '!bg-darkBlue !text-white !font-[600]' : ''}`} onClick={()=>setValue('single')}>إضافة بالمستفيد</div>
                    <div className={`w-[50%] h-[40px] bg-white rounded-[30px] leading-[40px] text-center text-[20px] text-grey-900 font-[200] select-none cursor-pointer ${value === 'bulk' ? '!bg-darkBlue !text-white !font-[600]' : ''}`} onClick={()=>setValue('bulk')}>إضافة بالملف</div>
                </div>
            </div>
        </div>
    )
}